module.exports = __webpack_public_path__ + "static/img/download_img_pad.149b797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_img_pad.png
// module id = d+fQ
// module chunks = 10